import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Upsert from '../../components/form/Upsert'
import Modal from '../../components/popup/Modal'
import { isNumeric } from '../../utils/string'

const fields = [
  'nguoiDuyetId',
  'mucDich',
  'diaChi',
  'email',
  'soDienThoai',
  'soBan',
  'caNhan',
  'ghiChu',
  'file',
]
const required = ['nguoiDuyetId', 'mucDich', 'soBan']
const types = { nguoiDuyetId: 'select', caNhan: 'checkbox', ghiChu: 'text-area', file: 'file' }
const name = {
  nguoiDuyetId: 'Người duyệt',
  mucDich: 'Mục đích',
  diaChi: 'Địa chỉ',
  email: 'Email',
  soDienThoai: 'Điện thoại',
  soBan: 'Số bản',
  ghiChu: 'Ghi chú',
  caNhan: 'Cá nhân',
  file: 'File đính kèm',
}
const col = {
  nguoiDuyetId: 12,
  mucDich: 12,
  diaChi: 12,
  email: 5,
  soDienThoai: 4,
  soBan: 3,
  caNhan: 12,
  ghiChu: 12,
  file: 12,
}

const ViewBanSao = (props) => {
  const { visible, toggle, canEdit, data, submit, disable } = props
  const [error, setError] = useState({})
  const [value, setValue] = useState({})
  const users = useSelector((state) => state.user.users)

  useEffect(() => {
    setValue({ ...data })
  }, [data])
  useEffect(() => setError({}), [visible])

  const options = {
    nguoiDuyetId: users.map((item) => {
      return { ...item, name: item.fullname }
    }),
  }
  const onSubmit = () => {
    const newError = {}

    if (!isNumeric(value.soBan)) {
      newError.soBan = 'Số bản không đúng định dạng'
    }
    required.forEach((key) => {
      if (!fields.find((i) => key === i)) {
        return
      }
      if (value[key] === '' || value[key] === undefined || value[key] === null) {
        newError[key] = `Trường ${name[key] || key} là bắt buộc!`
      }
    })
    setError(newError)
    if (Object.keys(newError).length === 0) {
      if (submit) submit(value)
    }
  }

  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button label="Huỷ" className="p-button-secondary mr-2" onClick={toggle} />
      {canEdit && <Button label="Lưu" onClick={onSubmit} />}
    </div>
  )

  return (
    <Modal visible={visible} toggle={toggle} footer={footer}>
      <Upsert
        values={value}
        required={required}
        setValues={setValue}
        name={name}
        fields={fields}
        types={types}
        error={error}
        options={options}
        col={col}
        disable={disable}
      />
    </Modal>
  )
}
export default ViewBanSao
